import { ReactNode, type FC } from 'react';

// MUI
import Typography, { type TypographyProps } from '@mui/material/Typography';

// screen
import { SMALL_FONT_SIZE } from 'modules/map/components/pdf-print-form/utils';

interface SizedTextProps extends TypographyProps {
  children: ReactNode;
}

const SizedText: FC<SizedTextProps> = ({ children, sx }) => {
  return <Typography sx={{ fontSize: SMALL_FONT_SIZE, ...sx }}>{children}</Typography>;
};

export default SizedText;
